import { MandatePermissions } from './../../models/enum/mandate-permissions.enum';
import { MandateService } from './../../services/mandate/mandate.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const mandatePermissions = MandatePermissions;

  const mandateService = inject(MandateService);
  const router = inject(Router);

  if(route.url.join('').includes('medications')) {
    return mandateService.hasAccess(mandatePermissions.consultMedicationScheme)
      .pipe(
        map(hasAccess => {
          if(hasAccess) {
            return true;
          } else {
            return router.parseUrl('/homepage');
          }
        })
      );
  } else if(route.url.join('').includes('diary-notes')) {
    return mandateService.hasAccess(mandatePermissions.consultDiaryNotes)
      .pipe(
        map(hasAccess => {
          if(hasAccess) {
            return true;
          } else {
            return router.parseUrl('/homepage');
          }
        })
      );
  } else {
    return false;
  };
};
